<style>
    .nocopy {
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
    .div-ISelect {
        background-color: #83cfea !important;
    }

    td {
        cursor: pointer;
    }
</style>
<template>
    <el-container style="height: 100%">
        <div id="myBox">
            <div id="silderLeft">
                <div class="menuList">
                    <el-aside v-if="$root.windowstyle == 1" style="height: 100%;overflow: hidden;width: auto;background: #545c64;">
                        <common-aside></common-aside>
                    </el-aside>
                    <el-aside v-if="$root.windowstyle == 2" style="height: 100%;overflow: hidden;width: auto;background: rgb(51,133,86);">
                        <common-aside></common-aside>
                    </el-aside>
                    <el-aside v-if="$root.windowstyle == 3" style="height: 100%;overflow: hidden;width: auto;background: rgb(59,105,161);">
                        <common-aside></common-aside>
                    </el-aside>
                    <el-aside v-if="$root.windowstyle == 4" style="height: 100%;overflow: hidden;width: auto;background: rgb(235,115,154);">
                        <common-aside></common-aside>
                    </el-aside>
                </div>
                <div id="moveBtn"></div>
            </div>
            <div id="silderRight">
                <div style="width:100%;height:100%">
                    <el-container>
                    <el-header v-if="$root.windowstyle == 1" style="background-color: #333;">
                        <common-header></common-header>
                    </el-header>
                    <el-header v-if="$root.windowstyle == 2" style="background-color: #0e5e0e;">
                        <common-header></common-header>
                    </el-header>
                    <el-header v-if="$root.windowstyle == 3" style="background:rgb(35,71,114)">
                        <common-header></common-header>
                    </el-header>
                    <el-header v-if="$root.windowstyle == 4" style="background:rgb(167,45,85)">
                        <common-header></common-header>
                    </el-header>
                    <!--加入CommonTab-->
                    <common-tab></common-tab>
                    <el-main>
                        <div id="divSelectTD"></div>
                        <!--<div id="fuzhi">复制</div>-->
                        <transition name="fade" mode="out-in">
                            <keep-alive :include="exlist">
                                <router-view/>
                                <!--<router-view v-if="$router.currentRoute.meta.keepAlive " />-->
                            </keep-alive>
                        </transition>
                    </el-main>
                    <!-- <el-footer></el-footer> -->
                </el-container>
                </div>
            </div>
        </div>



    </el-container>
</template>

<script>
    import CommonAside from '../components/CommonAside';
    import CommonTab from '../components/CommonTab';
    import CommonHeader from '../components/CommonHeader';
    import $ from 'jquery'

    export default {
        components: {
            CommonAside,
            CommonHeader,
            CommonTab
        },
        data() {
            return {
                transitionName: '',
                exlist: sessionStorage.getItem('keepview'),
            };
        },
        create() {
            this.exlist = JSON.parse(sessionStorage.getItem('keepview'));
        },
        mounted() {
            let that = this
            that.drag()
            that.handlebtn()
            window.addEventListener('resize', this.handlebtn);
        },
        beforeDestroy() {
            // 移除监听器
            window.removeEventListener('resize', this.handlebtn);
        },
        methods: {
            drag(){
                let total = document.getElementById("myBox");
                let right = document.getElementById("silderRight");
                let left = document.getElementById("silderLeft");
                let drag = document.getElementById("moveBtn");
                drag.onmouseover = function (e) {
                    if(e.clientX < 200){
                        drag.style.cursor="default"
                    } else {
                        drag.style.cursor="col-resize"
                    }
                };
                drag.onmousedown = function(e) {
                    let init = e.clientX;
                    console.log(init)
                    let initWidth = left.offsetWidth;
                    if(initWidth > 200){
                        document.onmousemove = function(e) {
                            var end = e.clientX;
                            if(end > 240){
                                var newWidth = end - init + initWidth;
                                left.style.width = newWidth + "px";
                                right.style.width = total.clientWidth - newWidth + 'px'
                            }else{
                                end = 240;
                                // 最小宽度242
                                left.style.width = 232 + "px";
                            }
                        };
                        document.onmouseup = function() {
                            document.onmousemove = document.onmouseup = null;
                        };
                    }
                };
            },
            handlebtn(){
                // 调整左侧菜单栏高度
                let scrollbar = document.getElementsByClassName('menu')
                for(let i =0;i<scrollbar.length;i++){
                    scrollbar[i].style.height = window.innerHeight - 60 + "px"
                }
                //调整按钮菜单栏宽度
                if(document.getElementsByClassName('contt').length != 0){
                    let headerW = document.getElementsByClassName('el-header')[0].clientWidth
                    let headerL = document.getElementsByClassName('l-content')[0].clientWidth
                    let headerR = document.getElementsByClassName('r-content')[0].clientWidth
                    let width = headerW - headerL - headerR
                    if(width <= 70){
                        document.getElementsByClassName('contt')[0].style.width = '0px'
                    }
                    else if(width < 545 && width>70){
                        document.getElementsByClassName('contt')[0].style.width = width - 90 + 'px'
                    }  else{
                        document.getElementsByClassName('contt')[0].style.width = "545px"
                    }
                }
            }
        },
        watch: {
            //使用watch 监听$router的变化
            $route(to, from) {
                // console.log(to);
                // console.log(from);
                const routeDeep = ['/'];
                const toDepth = routeDeep.indexOf(to.path);
                const fromDepth = routeDeep.indexOf(from.path);
                this.transitionName = toDepth > fromDepth ? 'slide-left' : 'slide-right';
                this.exlist = JSON.parse(sessionStorage.getItem('keepview'));
                // console.log("缓存页面》》》》》》",this.exlist)
                // alert(123)
                $(document).unbind('keydown');
                $(".div-ISelect").removeClass("div-ISelect")
                $(".nocopy").removeClass("nocopy")
            }
        }
    };
    $(document).ready(function () {

    })
    // var tableNode = document.createElement("table");//获得对象
    // tableNode.setAttribute("id", "table")
    // //alert(row);
    // //上面确定了 现在开始创建
    // for (var x = 0; x < row; x++) {
    //     var trNode = tableNode.insertRow();
    //     for (var y = 0; y < cols; y++) {
    //         var tdNode = trNode.insertCell();
    //         //tdNode.innerHTML="单元格"+(x+1)+"-"+(y+1);
    //         tdNode.innerHTML = $("tr:eq(" + (minrow + x) + ") td:eq(" + (mincol + y) + ")").text();
    //     }
    // }
    // document.getElementById("divSelectTD").appendChild(tableNode);//添加到那个位置
    //
    // initForm() {
    //     var isMouseDown = false,
    //         isHighlighted
    //     //添加点击事件
    //     $("td").mousedown(function () {
    //         // alert(2);
    //         isMouseDown = true;
    //         var currentTD = $(this);
    //         $("tr:gt(0) td").each(function (i) {
    //             $(this).removeClass('div-ISelect');
    //         })
    //         firstindexrow = currentTD.parent().index();
    //         firstindexcol = currentTD.index();
    //         curindexrow = currentTD.parent().index();
    //         curindexcol = currentTD.index();
    //         $("tr:eq(" + curindexrow + ") td:eq(" + curindexcol + ")").addClass("div-ISelect");
    //         console.log("curindexrow" + curindexrow)
    //         console.log("curindexcol" + curindexcol)
    //         minrow = curindexrow > firstindexrow ? firstindexrow : curindexrow;
    //         mincol = curindexcol > firstindexcol ? firstindexcol : curindexcol;
    //         maxrow = curindexrow > firstindexrow ? curindexrow : firstindexrow;
    //         maxcol = curindexcol > firstindexcol ? curindexcol : firstindexcol;
    //         return false;
    //     }).mouseenter(function (e) {
    //         if (isMouseDown) {
    //             var currentTD = $(this);
    //             $("tr:gt(0) td").each(function (i) {
    //                 $(this).removeClass('div-ISelect');
    //             })
    //             curindexrow = currentTD.parent().index();
    //             curindexcol = currentTD.index();
    //             minrow = curindexrow > firstindexrow ? firstindexrow : curindexrow;
    //             mincol = curindexcol > firstindexcol ? firstindexcol : curindexcol;
    //             maxrow = curindexrow > firstindexrow ? curindexrow : firstindexrow;
    //             maxcol = curindexcol > firstindexcol ? curindexcol : firstindexcol;
    //             console.log("minrow" + minrow)
    //             console.log("mincol" + mincol)
    //             console.log("maxrow" + maxrow)
    //             console.log("maxcol" + maxcol)
    //             for (var i = minrow; i <= maxrow; i++) {
    //                 for (var j = mincol; j <= maxcol; j++) {
    //                     $("tr:eq(" + i + ") td:eq(" + j + ")").addClass("div-ISelect");
    //                     console.log("i" + i + "j" + j)
    //                 }
    //             }
    //         }
    //     });
    //
    //     $(document).mouseup(function () {
    //         isMouseDown = false;
    //     });
    //
    //     $("#fuzhi").click(function () {
    //
    //         //JS动态创建表格
    //         //记录原始表格选中单元格开始点 和结束点 创建新的表格用于复制
    //         //var fdoms =
    //         console.log('maxrow' + maxrow);
    //         var row = maxrow - minrow + 1;
    //         var cols = maxcol - mincol + 1;
    //         console.log('frow' + row);
    //         console.log('fcols' + cols);
    //         // this.createTable(frow, fcols);
    //         var tableNode = document.createElement("table");//获得对象
    //         tableNode.setAttribute("id", "table")
    //         //alert(row);
    //         //上面确定了 现在开始创建
    //         for (var x = 0; x < row; x++) {
    //             var trNode = tableNode.insertRow();
    //             for (var y = 0; y < cols; y++) {
    //                 var tdNode = trNode.insertCell();
    //                 //tdNode.innerHTML="单元格"+(x+1)+"-"+(y+1);
    //                 tdNode.innerHTML = $("tr:eq(" + (minrow + x) + ") td:eq(" + (mincol + y) + ")").text();
    //                 console.log(tdNode.innerHTML)
    //             }
    //         }
    //         document.getElementById("divSelectTD").appendChild(tableNode);//添加到那个位置
    //         let range = document.createRange();
    //         window.getSelection().removeAllRanges();
    //         const aa = document.getElementById('table');  // 这里是你要选择复制的文本dom节点  根据ID匹配
    //         range.selectNode(aa);
    //         window.getSelection().addRange(range);
    //         document.execCommand('copy');
    //         window.getSelection().removeAllRanges();
    //         document.getElementById("divSelectTD").innerHTML = "";
    //         alert("复制成功");
    //     });
    // },

    // $(document).ready(function(){
    //     //执行jquery
    //     var firstindexrow;
    //     var firstindexcol;
    //     var curindexrow;
    //     var curindexcol;
    //     var minrow;
    //     var mincol;
    //     var maxrow;
    //     var maxcol;
    //     initForm();
    //
    //     function initForm() {
    //         var isMouseDown = false,
    //             isHighlighted
    //         //添加点击事件
    //         $("td").mousedown(function () {
    //             // alert(1);
    //             isMouseDown = true;
    //             var currentTD = $(this);
    //             $("tr:gt(0) td").each(function (i) {
    //                 $(this).removeClass('div-ISelect');
    //             })
    //             firstindexrow = currentTD.parent().index();
    //             firstindexcol = currentTD.index();
    //             curindexrow = currentTD.parent().index();
    //             curindexcol = currentTD.index();
    //             $("tr:eq(" + curindexrow + ") td:eq(" + curindexcol + ")").addClass("div-ISelect");
    //             console.log("curindexrow" + curindexrow)
    //             console.log("curindexcol" + curindexcol)
    //             minrow = curindexrow > firstindexrow ? firstindexrow : curindexrow;
    //             mincol = curindexcol > firstindexcol ? firstindexcol : curindexcol;
    //             maxrow = curindexrow > firstindexrow ? curindexrow : firstindexrow;
    //             maxcol = curindexcol > firstindexcol ? curindexcol : firstindexcol;
    //             return false;
    //         }).mouseenter(function (e) {
    //             if (isMouseDown) {
    //                 var currentTD = $(this);
    //                 $("tr:gt(0) td").each(function (i) {
    //                     $(this).removeClass('div-ISelect');
    //                 })
    //                 curindexrow = currentTD.parent().index();
    //                 curindexcol = currentTD.index();
    //                 minrow = curindexrow > firstindexrow ? firstindexrow : curindexrow;
    //                 mincol = curindexcol > firstindexcol ? firstindexcol : curindexcol;
    //                 maxrow = curindexrow > firstindexrow ? curindexrow : firstindexrow;
    //                 maxcol = curindexcol > firstindexcol ? curindexcol : firstindexcol;
    //                 console.log("minrow" + minrow)
    //                 console.log("mincol" + mincol)
    //                 console.log("maxrow" + maxrow)
    //                 console.log("maxcol" + maxcol)
    //                 for (var i = minrow; i <= maxrow; i++) {
    //                     for (var j = mincol; j <= maxcol; j++) {
    //                         $("tr:eq(" + i + ") td:eq(" + j + ")").addClass("div-ISelect");
    //                         console.log("i" + i + "j" + j)
    //                     }
    //                 }
    //             }
    //         });
    //
    //         $(document).mouseup(function () {
    //             isMouseDown = false;
    //         });
    //
    //         $("#fuzhi").click(function () {
    //
    //             //JS动态创建表格
    //             //记录原始表格选中单元格开始点 和结束点 创建新的表格用于复制
    //             //var fdoms =
    //             console.log('maxrow' + maxrow);
    //             var frow = maxrow - minrow + 1;
    //             var fcols = maxcol - mincol + 1;
    //             console.log('frow' + frow);
    //             console.log('fcols' + fcols);
    //             createTable(frow, fcols)
    //             let range = document.createRange();
    //             window.getSelection().removeAllRanges();
    //             const aa = document.getElementById('table');  // 这里是你要选择复制的文本dom节点  根据ID匹配
    //             range.selectNode(aa);
    //             window.getSelection().addRange(range);
    //             document.execCommand('copy');
    //             window.getSelection().removeAllRanges();
    //             document.getElementById("divSelectTD").innerHTML = "";
    //             alert("复制成功");
    //         });
    //     }
    //
    //
    //
    // function createTable(row, cols) {
    //     var tableNode = document.createElement("table");//获得对象
    //     tableNode.setAttribute("id", "table")
    //     //alert(row);
    //     //上面确定了 现在开始创建
    //     for (var x = 0; x < row; x++) {
    //         var trNode = tableNode.insertRow();
    //         for (var y = 0; y < cols; y++) {
    //             var tdNode = trNode.insertCell();
    //             //tdNode.innerHTML="单元格"+(x+1)+"-"+(y+1);
    //             tdNode.innerHTML = $("tr:eq(" + (minrow + x) + ") td:eq(" + (mincol + y) + ")").text();
    //         }
    //     }
    //     document.getElementById("divSelectTD").appendChild(tableNode);//添加到那个位置
    // }
    // });
</script>
<style lang="scss" scoped>

    .el-main {
        overflow-x: hidden;
        width: 100%;
        position: relative;
        padding: 0 20px;
        margin-top: -10px;
    }

    .fade-enter {
        opacity: 0;
    }

    .fade-leave {
        opacity: 1;
    }

    .fade-enter-active {
        transition: opacity 0.5s;
    }

    .fade-leave-active {
        opacity: 0;

        transition: opacity 0.5s;
    }

    .slide-right-enter-active,
    .slide-right-leave-active,
    .slide-left-enter-active,
    .slide-left-leave-active {
        transition: opacity 0.3s;
        overflow: hidden;
    }

    .slide-right-enter {
        opacity: 0;
        transform: translateX(30px);
    }

    .slide-right-leave-active {
        opacity: 0;
        transform: translateX(30px);
    }

    .slide-left-enter {
        opacity: 0;
        transform: translateX(30px);
    }

    .slide-left-leave-active {
        opacity: 0;
        transform: translateX(30px);
    }

    #myBox{
        width: 100%;;
        display: flex;
    }
    #silderLeft{
        width: 240px;
        position: relative;
    }
    /* 拖动条 */
    #moveBtn{
        height: 100%;
        width: 8px;
        /* opacity: 0; */
        position: absolute;
        right: 0px;
        top: 0;
        //cursor: col-resize;
    }
    #menuList{
    }
    #silderRight{
        width: calc(100% - 240px);
        height: 100%;
        flex: 1;
    }
</style>
